import styled, { css } from 'styled-components';

export const DivText = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    max-width: 476px;
    width: 50%;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      max-width: 100%;
    }

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      align-items: center;
      max-width: 573px;
      text-align: center;
      width: 100%;
    }
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${theme.v3.font.sizes['2xlarge']};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: 140%;
    margin: 0px 0px 20px 0px;

    span {
      color: ${theme.v3.colors.brand.snappyBlue[50]};
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.large};
      margin: 0 auto 16px auto;
    }

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      max-width: 100%;
    }
  `}
`;

export const WrapperDescription = styled.div`
  ${({ theme }) => css`
    max-width: 476px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      max-width: 100%;
    }
  `}
`;
